import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Send authorization code to get access token
 * @param {*} code OAuth code
 * @param {*} state 
 * {"code":"eyJhbGACLqg.......","state":"token_uri*FHIR_server"}
 * @returns 
 */
async function getOAuthAccessToken(code, state) {
  if (state) {
    let [value1, value2] = state.split('*');
    let oauth2_token_uri = decodeURIComponent(value1);
    let fhir_server = decodeURIComponent(value2);
    //WriteToLog('getOAuthAccessToken FHIR_SERVER: ' + fhir_server);

    if (oauth2_token_uri !== undefined) {
      const ehrconfig = await axios.get('ehrconfig.json');
      let config = ehrconfig.data[fhir_server];
      //WriteToLog("EHR Config getOAuthAccessToken: " + JSON.stringify(config));

      let oauth2_token_parm = ['grant_type=authorization_code',
        '&code=', encodeURIComponent(code), 
        '&redirect_uri=', encodeURIComponent(config['PICU_REDIRECT']),
        '&client_id=', config['PICU_CLIENT_ID']].join('');

      let tokenRes = await axios.post(oauth2_token_uri, oauth2_token_parm, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      })
      .catch(function (error) { 
        if (error.response) {
          WriteToLog("getOAuthAccessToken error.response.data: " + JSON.stringify(error.response));
          WriteToLog("getOAuthAccessToken error.response.status: " + error.response.status);
        } else if (error.request) {
          WriteToLog("getOAuthAccessToken error.request: " + JSON.stringify(error.request));
        } else {
          WriteToLog("getOAuthAccessToken Error", error.message);
        }
        return "token expired";
      });

      return(tokenRes.data);
    }
  } else {
    WriteToLog('getOAuthAccessToken state is null');
  }
}

export default getOAuthAccessToken;
